export const verifyExists = (dataInfo, value) => {
  const searchExists = dataInfo.find((index) => (index.slug === value));
  if (searchExists) {
    return true;
  }
  return false;
};

export const verifyExistsProject = (dataInfo, value) => {
  const searchExists = dataInfo.find((index) => (index.slug === value));
  if (searchExists) {
    return true;
  }
  return false;
};

const normalizePath = (path) => path
  .split('/')
  .map((segment) => (segment.startsWith(':') ? ':param' : segment))
  .join('/');

export const verifyAvailableUrl = (dataInfo, value) => {
  const normalizeInValue = normalizePath(value);
  return !dataInfo.some((index) => (normalizePath(index.url) === normalizeInValue));
};
